const customerList = [
    {
        id: "1",

        img: "assets/images/users/32/avatar-2.jpg",
        name: "Javon Pouros",
        email: "rashawn@aldawal.com",
        phone: "+(253) 12345 67890",
        create_date: "28 Feb, 2023",
        status: "Unactive"
    },
    {
        id: "2",
        img: "assets/images/users/32/avatar-3.jpg",
        name: "Willy Gulgowski",
        email: "gulgowski@aldawal.com",
        phone: "+(152) 32165 49873",
        create_date: "20 Feb, 2023",
        status: "Block"
    },
    {
        id: "3",
        img: "assets/images/users/32/avatar-4.jpg",
        name: "Verona Mosciski",
        email: "vmosciski@aldawal.com",
        phone: "+(231) 14562 32165",
        create_date: "16 Feb, 2023",
        status: "Active"
    },
    {
        id: "4",
        img: "assets/images/users/48/avatar-5.jpg",
        name: "Vinnie Huels",
        email: "vinnie@aldawal.com",
        phone: "+(44) 98765 32104",
        create_date: "23 Jan, 2023",
        status: "Active"
    },
    {
        id: "5",
        img: "assets/images/users/32/avatar-6.jpg",
        name: "Deondre Huel",
        email: "rashawn@aldawal.com",
        phone: "+(251) 25874 13690",
        create_date: "17 Jan, 2023",
        status: "Active"
    },
    {
        id: "6", img: "assets/images/users/32/avatar-7.jpg",
        name: "Nelson Schaden",
        email: "nelson@aldawal.com",
        phone: "+(92) 67890 12345",
        create_date: "02 Feb, 2023",
        status: "Unactive"
    },
    {
        id: "7",
        img: "assets/images/users/32/avatar-8.jpg",
        name: "Juanita Price",
        email: "juanitaprice@aldawal.com",
        phone: "+(62) 35791 15935",
        create_date: "29 Dec, 2022",
        status: "Block"
    },
    {
        id: "8",
        img: "assets/images/users/32/avatar-9.jpg",
        name: "Mac Gyver",
        email: "macGyver@aldawal.com",
        phone: "+(251) 15935 35795",
        create_date: "24 Dec, 2022",
        status: "Active"
    },
    {
        id: "9",
        img: "assets/images/users/32/avatar-10.jpg",
        name: "Zachary Stokes",
        email: "zacharystokes@aldawal.com",
        phone: "+(532) 35795 15935",
        create_date: "14 Dec, 2022",
        status: "Active"
    },
    {
        id: "10",
        img: "assets/images/users/32/user-dummy-img.jpg",
        name: "Sarai Schmidt",
        email: "sschmidt@aldawal.com",
        phone: "+(120) 15935 32165",
        create_date: "08 Dec, 2022",
        status: "Block"
    },
    {
        id: "11",
        img: "assets/images/users/avatar-1.jpg",
        name: "Ubaldo Bartell",
        email: "ubaldobartell@aldawal.com",
        phone: "+(105) 93521 23165",
        create_date: "01 Dec, 2022",
        status: "Unactive"
    },
    {
        id: "12",
        img: "assets/images/users/32/avatar-2.jpg",
        name: "Soledad Vandervort",
        email: "vandervort@aldawal.com",
        phone: "+(210) 95162 15935",
        create_date: "24 Nov, 2022",
        status: "Active"
    },
    {
        id: "13",
        img: "assets/images/users/32/avatar-3.jpg",
        name: "Marcelino Smith",
        email: "marcelino@aldawal.com",
        phone: "+(512) 34682 17935",
        create_date: "21 Nov, 2022",
        status: "Active"
    }
]

export { customerList }